import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
// import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const app = initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
})

const auth = getAuth(app)
// const db = initializeFirestore(app, {
//   localCache:
//     persistentLocalCache({
//       tabManager: persistentMultipleTabManager()
//     })
// })
const db = getFirestore(app)
const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_REGION)
const storage = getStorage(app, 'gs://genji-dev.firebasestorage.app')

export { auth, db, functions, storage }